import { useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";
import { detectLang } from "./ListingTranslate";

const L = {
  en: { fr: "Translate to French", en: "Translate to English", orig: "Show original", from: { en: "Automatically translated from English", fr: "Automatically translated from French" } },
  fr: { fr: "Traduire en français", en: "Traduire en anglais", orig: "Voir l'original", from: { en: "Traduit automatiquement de l'anglais", fr: "Traduit automatiquement du français" } },
};

// Profile bio / about text with a smart translate button that offers the other language.
export const ProfileText = ({ userId, field, text, className, testid }) => {
  const { lang } = useLanguage();
  const [out, setOut] = useState(null);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const src = detectLang(text);
  const target = src === "fr" ? "en" : "fr";
  const lab = L[lang === "fr" ? "fr" : "en"];
  const run = async () => {
    if (out?.src === text) return setShow(true);
    setBusy(true);
    try {
      const { data } = await api.post(`/users/${userId}/translate`, null, { params: { field, lang: target } });
      if (data.same) toast(lab.orig);
      else { setOut({ src: text, text: data.text }); setShow(true); }
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  const active = show && out?.src === text;
  return (
    <div>
      <p className={className} data-testid={testid}>{active ? out.text : text}</p>
      <div className="mt-1.5 flex items-center gap-3 flex-wrap">
        <button type="button" onClick={active ? () => setShow(false) : run} disabled={busy} data-testid={`${testid}-translate-btn`} data-target-lang={target}
          className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold text-[#12234A] hover:border-[#F5551E] hover:text-[#F5551E] transition-colors disabled:opacity-60">
          {busy ? <Loader2 size={13} className="animate-spin" /> : <Languages size={13} />} {active ? lab.orig : lab[target]}
        </button>
        {active && <span className="text-xs text-slate-400" data-testid={`${testid}-translated-note`}>{lab.from[src]}</span>}
      </div>
    </div>
  );
};
